// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/sbg-sens-announcements/sbg-sens-announcements.component.scss
// module id = 732
// module chunks = 0